// extracted by mini-css-extract-plugin
export var carrierIcon = "_u3-0";
export var carrierLogo = "_u3-1";
export var detailsSection = "_u3-2";